import { Switch, Route } from "wouter";
import { ROUTES } from "./Routes";
import Home from "../pages/Home";
import About from "../pages/About";
import Services from "../pages/Services";
import Portfolio from "../pages/Portfolio";
import Careers from "../pages/Careers";
import Contact from "../pages/Contact";
import Blog from "../pages/Blog";
import BlogDetail from "../pages/BlogDetail";

const AppRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.HOME.path} component={Home} />
      <Route path={ROUTES.ABOUT.path} component={About} />
      <Route path={ROUTES.SERVICE.path} component={Services} />
      <Route path={ROUTES.PORTFOLIO.path} component={Portfolio} />
      <Route path={ROUTES.CAREERS.path} component={Careers} />
      <Route path={ROUTES.CONTACT.path} component={Contact} />
      <Route path={ROUTES.BLOG.path} component={Blog} />
      <Route path="/blog/:slug" component={BlogDetail} />
      <Route path="*">
        <div style={{ padding: "100px", minHeight: "80vh", textAlign: "center" }}>404 Not Found</div>
      </Route>
    </Switch>
  );
};

export default AppRoutes;
